// extracted by css-extract-rspack-plugin
export default {"animatePath":"_animatePath_xxqpq","drawUndraw":"_drawUndraw_JFlcg"};